// extracted by mini-css-extract-plugin
module.exports = {"pt-obs-department-table":"pt-obs-department-table-f60f98c0541658668d20aa320ede29c1"};